/**
 * Hook for the per-session coverage report (F3 accountability guarantee).
 */

import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { getSessionCoverage } from '@/api/endpoints';
import type { CoverageReport } from '@/types/api.types';

export function useSessionCoverage(sessionId: string | null) {
  return useQuery<CoverageReport>({
    queryKey: queryKeys.sessionCoverage(sessionId ?? ''),
    queryFn: () => getSessionCoverage(sessionId as string),
    enabled: !!sessionId,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
